import Vue from 'vue'

import YDUI from 'vue-ydui'
/* 相当于import YDUI from 'vue-ydui/ydui.rem.js' */
import 'vue-ydui/dist/ydui.rem.css'

import global_ from '@/components/global.vue'

Vue.use(YDUI)
Vue.prototype.GLOBAL = global_

var routes = [
  {
    path: '/',
    component: resolve => require(['@/components/loginFrame.vue'], resolve),
    name: '志愿招募',
    redirect: 'home',
    hidden: true,
    children: [
      {
        path: '/Login',
        name: 'login',
        component: resolve => require(['@/view/login.vue'], resolve),
        meta: {
          title: '登录'
        }
      },
      {
        path: '/registPage',
        name: 'registPage',
        component: resolve => require(['@/view/registPage.vue'], resolve),
        meta: {
          title: '注册'
        }
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: resolve => require(['@/view/resetPassword.vue'], resolve),
        meta: {
          title: '重置密码'
        }
      },
    ]
  },
  {
    path: '/',
    component: resolve => require(['@/components/homeFrame.vue'], resolve),
    name: '志愿者医生',
    redirect: 'home',
    hidden: true,
    children: [

      {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/pc/home.vue'], resolve),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/message',
        name: 'message',
        component: resolve => require(['@/pc/message.vue'], resolve),
        meta: {
          title: '募款捐助'
        }
      },
      {
        path: '/training',
        name: 'training',
        component: resolve => require(['@/pc/training.vue'], resolve),
        meta: {
          title: '培训'
        }
      },
      {
        path: '/examresult',
        name: 'examresult',
        component: resolve => require(['@/pc/examResult.vue'], resolve),
        meta: {
          title: '培训结果'
        }
      },
      {
        path: '/newRes',
        name: 'newRes',
        component: resolve => require(['@/pc/newRes.vue'], resolve),
        meta: {
          title: '培训结果'
        }
      },
      {
        path: '/exam',
        name: 'exam',
        component: resolve => require(['@/pc/exam.vue'], resolve),
        meta: {
          title: '考试'
        }
      },
      {
        path: '/newexam',
        name: 'newexam',
        component: resolve => require(['@/pc/newExam.vue'], resolve),
        meta: {
          title: '考试'
        }
      },
      {
        path: '/test',
        name: 'test',
        component: resolve => require(['@/pc/test.vue'], resolve),
        meta: {
          title: '考试'
        }
      },
      {
        path: '/examRecord',
        name: 'examRecord',
        component: resolve => require(['@/pc/examRecord.vue'], resolve),
        meta: {
          title: '成绩查询'
        }
      },
      {
        path: '/examGrade/:examId',
        name: 'examGrade',
        component: resolve => require(['@/pc/examGrade.vue'], resolve),
        meta: {
          title: '查询结果'
        }
      },
      {
        path: '/download',
        name: 'download',
        component: resolve => require(['@/pc/download.vue'], resolve),
        meta: {
          title: 'APP下载'
        }
      },
      {
        path: '/news',
        name: 'news',
        component: resolve => require(['@/pc/news.vue'], resolve),
        meta: {
          title: '新闻详情'
        }
      },
      {
        path: '/newDetail',
        name: "newDetail",
        component: () => import("@/pc/newDetail"),

      },

      {
        path: '/active',
        name: 'active',
        component: resolve => require(['@/pc/active.vue'], resolve),
        meta: {
          title: '活动详情'
        }
      },
      {
        path: '/activelist',
        name: 'activelist',
        component: resolve => require(['@/pc/activelist.vue'], resolve),
        meta: {
          title: '活动列表'
        }
      },
      {
        path: '/newscenter',
        name: 'newscenter',
        component: resolve => require(['@/pc/newscenter.vue'], resolve),
        meta: {
          title: '新闻中心'
        }
      },
      {
        path: '/intr',
        name: 'intr',
        component: resolve => require(['@/pc/intr.vue'], resolve),
        meta: {
          title: '协会介绍'
        }
      },
      {
        path: '/recruit',
        name: 'recruit',
        component: resolve => require(['@/pc/recruit.vue'], resolve),
        meta: {
          title: '志愿活动招募'
        }
      },
      {
        path: '/moveVolunteer',
        name: 'moveVolunteer',
        component: resolve => require(['@/pc/moveVolunteer.vue'], resolve),
        meta: {
          title: '志愿者招募'
        }
      },
      {
        path: '/contract',
        name: 'contract',
        component: resolve => require(['@/pc/contract.vue'], resolve),
        meta: {
          title: '志愿者招募'
        }
      },
      {
        path: '/applyState',
        name: 'applyState',
        component: resolve => require(['@/pc/applyState.vue'], resolve),
        meta: {
          title: '申请建立专家工作站'
        }
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: resolve => require(['@/pc/aboutUs.vue'], resolve),
        meta: {
          title: '北京凌锋公益基金会'
        }
      },
      {
        path: '/introduce',
        name: 'introduce',
        component: resolve => require(['@/pc/introduce.vue'], resolve),
        meta: {
          title: '北京凌锋公益基金会'
        }
      },


    ],
    linkActiveClass: 'actived'
  },
  {
    path: '/memberHomeFrame',
    component: resolve => require(['@/components/memberHomeFrame.vue'], resolve),
    name: '个人中心',
    children: [

      {
        path: '/myActivities', name: '活动列表',
        component: resolve => require(['@/pc/myActivities.vue'], resolve),
        meta: {title: '我的活动'},
        iconClass: 'el-icon-setting'
      },
      {
        path: '/regist',
        name: 'regist',
        component: resolve => require(['@/view/regist.vue'], resolve),
        meta: {
          title: '个人信息注册'
        },
        hidden: true,
      },

      {
        path: '/detail',
        name: '资料详情',
        component: resolve => require(['@/view/detail.vue'], resolve),
        meta: {
          title: '资料详情'
        },
        hidden: false,
        iconClass: 'el-icon-document'
      },
      {
        path: '/upfileupload',
        name: 'upfileupload',
        component: resolve => require(['@/view/upfileupload.vue'], resolve),
        meta: {
          title: '修改个人资料'
        },
        hidden: true,
      },
      {
        path: '/myactive',
        name: 'myactive',
        component: resolve => require(['@/view/myactive.vue'], resolve),
        meta: {
          title: '我的活动详情'
        },
        hidden: true,
      },
      {
        path: '/upbase',
        name: 'upbase',
        component: resolve => require(['@/view/upbase.vue'], resolve),
        meta: {
          title: '修改基本信息'
        },
        hidden: true,
      },
      {
        path: '/twocode',
        name: 'twocode',
        component: resolve => require(['@/view/twocode.vue'], resolve),
        meta: {
          title: '修改基本信息'
        },
        hidden: true,
      },
      {
        path: '/upcert',
        name: 'upcert',
        component: resolve => require(['@/view/upcert.vue'], resolve),
        meta: {
          title: '修改证书'
        },
        hidden: true,
      },
      {
        path: '/base',
        name: 'base',
        component: resolve => require(['@/view/base.vue'], resolve),
        meta: {
          title: '基本信息填写'
        },
        hidden: true,
      },
      {
        path: '/upeducation',
        name: 'upeducation',
        component: resolve => require(['@/view/upeducation.vue'], resolve),
        meta: {
          title: '修改教育经历'
        },
        hidden: true,
      },
      {
        path: '/upwork',
        name: 'upwork',
        component: resolve => require(['@/view/upwork.vue'], resolve),
        meta: {
          title: '修改工作经历'
        },
        hidden: true,
      },

      {
        path: '/send',
        name: 'send',
        component: resolve => require(['@/view/send.vue'], resolve),
        meta: {
          title: '提交审核'
        },
        hidden: true,
      },
      {
        path: '/addwork',
        name: 'addwork',
        component: resolve => require(['@/view/addwork.vue'], resolve),
        meta: {
          title: '添加工作经历'
        },
        hidden: true,
      },
      {
        path: '/addcert',
        name: 'addcert',
        component: resolve => require(['@/view/addcert.vue'], resolve),
        meta: {
          title: '添加证书'
        },
        hidden: true,
      },
      {
        path: '/addeducation',
        name: 'addeducation',
        component: resolve => require(['@/view/addeducation.vue'], resolve),
        meta: {
          title: '添加教育经历'
        },
        hidden: true,
      },
      {
        path: '/fileupload',
        name: 'fileupload',
        component: resolve => require(['@/view/fileupload.vue'], resolve),
        meta: {
          title: '个人资料上传'
        },
        hidden: true,
      },
      {
        path: '/footprint',
        name: 'footprint',
        component: resolve => require(['@/view/footprint.vue'], resolve),
        meta: {
          title: '行动足迹'
        },
      },
      {
        path: '/medicalRecord',
        name: 'medicalRecord',
        component: resolve => require(['@/view/medicalRecord.vue'], resolve),
        meta: {
          title: '病历管理'
        },
      },
      {
        path: '/medicalSave',
        name: 'medicalSave',
        component: resolve => require(['@/view/medicalSave.vue'], resolve),
        meta: {
          title: '添加病历'
        },
      },
      {
        path: '/myCert',
        name: 'myCert',
        component: resolve => require(['@/view/myCert.vue'], resolve),
        meta: {
          title: '我的证件'
        },
      },
      {
        path: '/editPhone',
        name: 'editPhone',
        component: resolve => require(['@/view/editPhone.vue'], resolve),
        meta: {
          title: '修改手机号'
        }
      },

    ]
  },
  {
    path: '/mobileFrame',
    component: resolve => require(['@/components/mobileFrame.vue'], resolve),
    name: '手机客户端',
    children:
      [
        {
          path: '/m/newsDetail',
          name: 'newsDetail',
          component: resolve => require(['@/mobile/newsDetail.vue'], resolve),
          meta: {
            title: '文章详情'
          },
        },
        {
          path: '/m/vdCert',
          name: 'vdCert',
          component: resolve => require(['@/mobile/vdCert.vue'], resolve),
          meta: {
            title: '证件详情'
          },
        },
        {
          path: '/m/vdMedal',
          name: 'vdMedal',
          component: resolve => require(['@/mobile/vdMedal.vue'], resolve),
          meta: {
            title: '勋章详情'
          },
        },
      ]
  },


];
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js